/* Fornetto - interacoes leves, sem dependencias */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(root) {
    var els = (root || document).querySelectorAll('[data-anim]');
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
  }

  function sweep() {
    var els = document.querySelectorAll('[data-anim]:not(.is-in)');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getBoundingClientRect().top < window.innerHeight * 0.95) els[i].classList.add('is-in');
    }
  }

  function initReveal(root) {
    var scope = root || document;
    var targets = scope.querySelectorAll('[data-anim]:not(.is-in)');
    if (!targets.length) return;
    if (reduce || !('IntersectionObserver' in window)) { revealAll(scope); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('is-in');
        io.unobserve(entries[i].target);
      }
    }, { rootMargin: '200px 0px 0px 0px', threshold: 0 });
    for (var j = 0; j < targets.length; j++) {
      if (targets[j].getBoundingClientRect().top < window.innerHeight * 0.95) { targets[j].classList.add('is-in'); continue; }
      io.observe(targets[j]);
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { sweep(); ticking = false; });
  }

  function initSticky() {
    if (document.querySelector('.f-sticky')) return;
    var sel = 'product-form-component button[type="submit"], .product-form button[type="submit"], add-to-cart-component button';
    var atc = document.querySelector(sel);
    if (!atc) return;
    var titleEl = document.querySelector('.product-information h1, .product-details h1, h1');
    var priceEl = document.querySelector('.price, product-price');
    if (!titleEl) return;

    var bar = document.createElement('div');
    bar.className = 'f-sticky';
    var info = document.createElement('div');
    info.className = 'f-sticky__info';
    var t = document.createElement('span');
    t.className = 'f-sticky__title';
    t.textContent = titleEl.textContent.trim();
    info.appendChild(t);
    if (priceEl) {
      var pr = document.createElement('span');
      pr.className = 'f-sticky__price';
      pr.textContent = priceEl.textContent.replace(/\s+/g, ' ').trim();
      info.appendChild(pr);
    }
    var btn = document.createElement('button');
    btn.className = 'f-sticky__btn';
    btn.type = 'button';
    btn.textContent = 'Add to cart';
    btn.addEventListener('click', function () {
      var live = document.querySelector(sel);
      if (live) live.click();
    });
    bar.appendChild(info); bar.appendChild(btn);
    document.body.appendChild(bar);
    document.body.classList.add('f-has-sticky');

    if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (e.isIntersecting || e.boundingClientRect.top > 0) bar.classList.remove('is-on');
      else bar.classList.add('is-on');
    }, { threshold: 0 });
    io.observe(atc);

    document.addEventListener('variant:update', function () {
      var p = document.querySelector('.price, product-price');
      var pn = bar.querySelector('.f-sticky__price');
      if (p && pn) pn.textContent = p.textContent.replace(/\s+/g, ' ').trim();
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    initReveal();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (/\/products\//.test(location.pathname)) setTimeout(initSticky, 400);
    document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
    document.addEventListener('shopify:section:select', function (e) { revealAll(e.target); });
  });

  window.addEventListener('load', function () {
    setTimeout(sweep, 600);
    setTimeout(sweep, 1800);
  });
})();